import { render, staticRenderFns } from "./ExportVentes.vue?vue&type=template&id=5513c8a6&scoped=true"
import script from "./ExportVentes.vue?vue&type=script&lang=js"
export * from "./ExportVentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5513c8a6",
  null
  
)

export default component.exports